import { NgModule } from '@angular/core';
import { NoDblClickDirective } from './no-dbl-click.directive';

@NgModule({
  imports: [

  ],
  declarations: [
    NoDblClickDirective
  ],
  exports: [
    NoDblClickDirective
  ]
})

export class NoDblClickModule {}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/directives/no-dbl-click/no-dbl-click.module.ts